import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { FormType } from '@fitogest/reactive-form-builder/interfaces';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { Filtering } from 'src/app/service/filtering/filtering';
import { RequestHandler } from '../../../../service/OffService/request-handler';
import { Utils } from 'src/app/common/utils';
import { TareasApiService } from '../../../../service/api/tareas-api.service';
import { DashboardService } from '../../../../service/events/dashboard.service';
import { BaseView } from '../../../base-view';
import { environment } from 'src/environments/environment';
import { FitoLocalesModel } from 'src/app/models/tareas/fito-locales.model';
import { FitoLocalesFormDefinition } from './fito-locales-form/form-control/form-definition';


@Component({
    selector: 'app-fito-locales',
    standalone: false,
    templateUrl: './fito-locales.component.html',
    styleUrls: ['./fito-locales.component.scss']
})
export class FitoLocalesComponent extends BaseView<FitoLocalesModel> implements OnInit, OnDestroy {
    public readonly serverUrl = environment.serverUrl;
    public readonly hasClients = environment.features.hasClients;
    public readonly showTareasFincas = environment.features.showTareasFincas;
    public readonly fincaName = environment.features.fincaName;

    public form: FitoLocalesFormDefinition | null = null;
    public getRequest!: RequestHandler<FitoLocalesModel[]>;
    public deleteRequest!: RequestHandler<FitoLocalesModel>;

    public override filtering: Filtering<FitoLocalesModel> = new Filtering<FitoLocalesModel>();
    public override canShow: Record<string, boolean> = {};
    public override model: FitoLocalesModel = {};

    public cols: ColInterface[] = [
        { field: 'id', header: 'Nº\xa0Ficha', filter: '' },
        { field: 'fecha', header: 'Fecha', filter: '' },
        { field: 'finca', header: 'Finca', filter: '', visible: this.showTareasFincas },
        { field: 'cliente', header: 'Cliente', filter: '', visible: this.hasClients },
        { field: 'local', header: 'Local', filter: '' },
        { field: 'producto', header: 'Producto', filter: '' },
        { field: 'num_registro', header: 'Nº registro', filter: '' },
        { field: 'materia_activa', header: 'Materia activa', filter: '' },
        { field: 'superficie', header: 'Superficie\xa0tratada', filter: '' },
        { field: 'motivo', header: 'Motivo\xa0fitosanitario', filter: '' }
    ];

    constructor(
        public tareasApi: TareasApiService,
        private readonly dashboardEvents: DashboardService,
        private readonly router: Router,
    ) {
        super(
            dashboardEvents,
            tareasApi.fitoLocales.GET,
            tareasApi.fitoLocales.DELETE,
        );

        this.getRequest = tareasApi.fitoLocales.GET;
        this.deleteRequest = tareasApi.fitoLocales.DELETE;
    }

    public ngOnInit(): void {
        this.dashboardEvents.setSubmenuItem('tareas', 'fito-locales');
    }

    public override ngOnDestroy(): void {
        Utils.unsuscribe([
            this.tareasApi.fitoLocales.GET,
        ]);
    }

    public globalVisualTransform(value: string): string {
        return value;
    }

    public globalConditionalStyle(): ColStylesInterface {
        return {};
    }

    public add(): void {
        this.router.navigate(['dashboard', 'fito-crear-locales']);
    }

    public edit(data: FitoLocalesModel): void {
        this.router.navigate(['dashboard', 'fito-editar-locales', data.id]);
    }

    public duplicate(data: FitoLocalesModel): void {
        this.router.navigate(['dashboard', 'fito-duplicar-locales', data.id]);
    }

    public override show(modal: string, data: FitoLocalesModel): void {
        super.show(modal, data);

        const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;

        this.form = new FitoLocalesFormDefinition(formType, data);
    }

    public override hide(modal: string): void {
        super.hide(modal);
        this.form = null;
    }
}
